<template>
  <div class="headerWrapper bar" :class="{'androidStyle':!ISANDROID}">
    <div class="header">
      <div class="returnIcon" @click="backTo">
      </div>
      <div class="title">
        移动办公
      </div>
      <div class="addPerson" @click='goTabs' v-if="showPerson">
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  export default {
    name: "VHeader",
    props: ['toList', 'from'],
    data() {
      return {
        showPerson: this.toList,
        comeFrom: this.from
      };
    },
    computed: {
      ...mapGetters(['getRouterState'])
    },
    mounted() {
      this.getIsAndroid();
    },
    methods: {
      backTo() {
        this.$store.commit('changeDirection', false);
        if (!this.getRouterState) {
          this.toLogin();
        } else {
          this.$router.go(-1);
          this.$store.commit('delRouter');
        }
      },
      getIsAndroid() {

      },
      goTabs() {
        this.$store.commit('changeDirection', true);
        this.$router.push('/tabs');
        this.$store.commit('addRouter');
      },
      toLogin() {
        // console.log('endendend');
        if (!this.ISANDROID) {
          window.location.href = "js-call://IOS/NavCallBack";
        } else {
          window.androidApi.backCalls();
        }
        return;
      }
    }
  };
</script>

<style lang='scss' scoped>
  @import "@/assets/scss/_mixin.scss";

  .headerWrapper {
    background: #ffffff;

    &.bar {
      @include display-flex();
      @include translate3d(0, 0, 0);
      @include user-select(none);
      position: absolute;
      right: 0;
      left: 0;
      z-index: 999;
      @include box-sizing(border-box);
      padding: 5px;
      width: 100%;
      border-width: 0;
      border-style: solid;
      border-top: 1px solid transparent;
      border-bottom: 1px solid rgba(249, 250, 252, 1);
      background-size: 0px;

      @media (min--moz-device-pixel-ratio: 1.5),
        (-webkit-min-device-pixel-ratio: 1.5),
        (min-device-pixel-ratio: 1.5),
        (min-resolution: 144dpi),
        (min-resolution: 1.5dppx) {
        border: none;
        background-image: linear-gradient(0deg,
          rgba(249, 250, 252, 1),
          rgba(249, 250, 252, 1),
          transparent 50%);
        background-position: bottom;
        background-size: 100% 1px;
        background-repeat: no-repeat;
      }

      height: 44px;

      .header {
        width: 100%;
        height: 100%;
        position: relative;
        box-sizing: border-box;

        // padding: 5px;
        .returnIcon {
          position: absolute;
          left: 0px;
          background: url(../assets/images/return.svg);
          @include background-size(50% 50%);
          background-repeat: no-repeat;
          background-origin: center center;
          background-position: 30% center;
          height: 100%;
          width: 34px;
          z-index: 9999;
        }

        .addPerson {
          position: absolute;
          right: 0px;
          background: url(../assets/images/addPerson.svg);
          @include background-size(50% 50%);
          background-repeat: no-repeat;
          background-origin: center center;
          background-position: center center;
          height: 100%;
          width: 34px;
          z-index: 9999;
        }

        .title {
          @include display-flex();
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          right: 0;
          font-size: 18px;
          font-family: MicrosoftYaHei;
          color: rgba(59, 72, 89, 1);
          flex-direction: row;
          justify-content: center;
          align-items: center;
          letter-spacing: 1px;
          text-align: center;
          line-height: 34px;
          z-index: 9992;
        }
      }

      &.androidStyle {
        height: 64px;
        padding-top: 25px;

        @media only screen and (width: 375px) and (height: 812px) and (-webkit-min-device-pixel-ratio: 3) {
          height: 88px;
          padding-top: 49px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/VHeader.vue